import { Box, useRealtime } from '@timelyapp/react';
import type { Props as DurationFormatProps } from 'components/DurationFormat';
import DurationFormat from 'components/DurationFormat';
import React from 'react';

interface Props extends DurationFormatProps {
  /** The original duration in total number of seconds */
  value: number;
  timerStartedOn?: number | null;
  format?: string;
  valueType?: 'seconds' | 'minutes' | 'hours';
  className?: string;
  timerButton?: React.ReactNode;
  alignItems?: React.CSSProperties['alignItems'];
}

const DurationRealtimeFormat: React.FC<Props> = props => {
  const { value, timerStartedOn, timerButton, alignItems = 'end', ...rest } = props;

  let calculatedValue = value;

  useRealtime();

  if (timerStartedOn) {
    calculatedValue += +new Date() / 1000 - timerStartedOn;
  }

  return (
    <Box.Row gap="small" alignItems={alignItems}>
      <DurationFormat {...rest} value={calculatedValue} />
      {timerButton}
    </Box.Row>
  );
};

export default DurationRealtimeFormat;
